<template>
  <div id="email" class="error-modal">
    <div class="close-btn">
      <div style="cursor: pointer" @click.esc="close">x</div>
    </div>
    <div class="error-modal-body">
      <div class="error-error text-center">
        <div class="choose-title">
          Та И-баримтын мэдээллээ баталгаажуулна уу.
        </div>
        <div class="choose-body">
          <div class="choose-body-item">
            <div class="col-md-12 row box-text">
              <p>
                Эрхэм хэрэглэгч та EBarimt-н хэрэглэгчийн дугаараа
                баталгаажуулна уу.
              </p>
            </div>
          </div>
          <div
            class="choose-body-item"
            v-if="
              this.user.vatCustomerNo != ebarimtInfo.loginName &&
              this.user.vatCustomerNo != ''
            "
          >
            <div class="col-md-12 row box-text">
              <p>
                Таны номинд бүртгэлтэй дугаар:
                <b>{{ this.user.vatCustomerNo }}</b>
              </p>
            </div>
          </div>
          <div class="choose-body-item">
            <div class="col-md-12 row box-text">
              <p>
                И-баримтад бүртгэлтэй дугаар: <b>{{ ebarimtInfo.loginName }}</b>
              </p>
            </div>
          </div>
          <div class="choose-body-item">
            <div class="col-md-12 row box-text">
              <p>Та И-баримтад бүртгэлтэй дугаараар сольж бүртгүүлэх үү?</p>
            </div>
          </div>
          <p class="my-info">
            Монголын хамгийн том Үндэсний сүлжээ Номин дэлгүүрийн аль ч
            салбараар үйлчлүүлэхдээ эрхэм хэрэглэгч та худалдан авалт хийсэн
            НӨАТ баримтаа автоматаар бүртгүүлэн, цахим талон авах боломжтой
            боллоо. Цаасны хэрэглээг бууруулж байгаль эх дэлхийгээ хайрлан
            хамгаалцгаая.
          </p>
        </div>

        <div class="choose-footer">
          <button class="confirm" @click="confirmUpdate('newVat')">
            Баталгаажуулах
          </button>

          <button
            v-if="
              this.user.vatCustomerNo != ebarimtInfo.loginName &&
              this.user.vatCustomerNo != ''
            "
            class="cancel"
            @click="confirmUpdate('oldVat')"
          >
            Хэвээр үлдээх
          </button>
        </div>
      </div>
    </div>
    <transition name="fade">
      <Success
        :successMessage="successMessage"
        v-if="successModal"
        @hideSuccessMessage="hideSuccessMessage"
      ></Success>
    </transition>
    <transition name="fade">
      <Error
        :errorMessage="errorMessage"
        v-if="errorModal"
        @hideErrorMessage="hideErrorMessage"
      ></Error>
    </transition>
  </div>
</template>

<script>
import Success from "@/views/plugin/success";
import Error from "@/views/plugin/error";
// import confirmInfoVue from "./confirmInfo.vue";
export default {
  props: {
    user: Object,
    ebarimtInfo: Object,
  },
  data() {
    return {
      successModal: false,
      successMessage: "",
      errorModal: false,
      errorMessage: "",
    };
  },
  methods: {
    close() {
      this.$emit("hideEbarimtInfo");
    },
    showSuccessMessage(message) {
      // console.log("sadas");
      this.$emit("showSuccessMessage", message);
    },
    hideErrorMessage() {
      this.errorMessage = "";
      this.errorModal = false;
    },
    confirmUpdate(type) {
      var vatNumber = null;
      if (type == "newVat") {
        vatNumber = this.ebarimtInfo.loginName;
      } else {
        vatNumber = this.user.vatCustomerNo;
      }
      this.confirmEbarimt(vatNumber);
    },
    confirmEbarimt(vatNumber) {
      let tokenId = localStorage.getItem("authToken");
      let userData = this.$auth.getMe();
      if (tokenId == null || userData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      var cardHolderInfId = userData.cardHolderInfId;

      var email = this.user.customerEMail;
      var phone = this.user.customerPhone;
      var homeAddress = this.user.customerAddressHome;
      var vatCustomerNo = vatNumber;
      var lastName = this.user.lastName;
      var firstName = this.user.firstName;
      var registerNo = this.user.customerRegNo;
      var districtId = this.user.customerAddressDistrict;
      var khorooNumber = this.user.customerAddressKhoroo;

      if (vatCustomerNo == null || vatCustomerNo == "") {
        this.errorModal = true;
        this.errorMessage =
          "Таны мэдээлэл баталгаажуулах боломжгүй байна! Та мэдээллээ шалгуулна уу.";
        return;
      }
      this.$bonusApi
        .post(
          `bonus-card/update/holderMyInfo`,
          {
            tokenId,
            cardHolderInfId,
            phone,
            email,
            districtId,
            khorooNumber,
            homeAddress,
            vatCustomerNo,
            firstName,
            lastName,
            registerNo,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          if (response.data.status === 1) {
            // this.close();
            this.createEbarimt(tokenId, cardHolderInfId, vatCustomerNo);
          } else {
            this.errorModal = true;
            this.errorMessage = response.data.message;
          }
        })
        .catch((error) => {
          this.errorModal = true;
          this.errorMessage =
            (error.response && error.response.data && error.response.data.message) ||
            "Мэдээлэл хадгалахад алдаа гарлаа.";
        });
    },
    createEbarimt(tokenId, cardHolderInfId, vatCustomerNo) {
      this.$axiosApi
        .post(`card/create/ebarimtInfo`, {
          tokenId,
          cardHolderInfId,
          vatCustomerNo,
        })
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.close();
            this.showSuccessMessage("Амжилттай баталгаажлаа");
          } else if (result.status === 100) {
            this.errorMessage = response.data.message;
            this.errorModal = true;
          } else if (result.status === 201) {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch((error) => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
  },
  components: {
    Success,
    Error,
  },
};
</script>

<style scoped>
.my-info {
  margin: 5px 20px !important;
  padding: 5px 20px !important;
  border: 1px solid #1660ab85;
  background: rgb(199 193 193 / 9%);
  color: black !important;
  font-weight: 300;
  font-size: 13px !important;
  text-align: center;
}
.close-btn {
  position: relative;
  color: #1660ab;
  flex-direction: row;
  justify-content: flex-end;
  /* width: 100%; */
  padding: 0 10px;
  font-size: 28px;
  right: -210px;
  z-index: 900;
  top: 20%;
}
.textRow {
  color: black;
  font-weight: 600;
  text-align: right;
}
.choose-title {
  font-size: 14px;
  padding: 10px 0;
  color: #1660ab;
  text-transform: uppercase;
}
.choose-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.choose-body .choose-body-item {
  flex-direction: row;
  display: flex;
  padding: 5px 30px;
}
.choose-body-item label {
  line-height: 1em;
  margin-left: 5px;
  font-weight: 400;
}
.choose-footer {
  display: flex;
  justify-content: space-around;
}
.choose-footer .confirm {
  color: #fff;
  background: #1660ab;
  border: 1px solid #1660ab;
}
.choose-footer .cancel {
  color: #fff;
  background: #434d57;
  border: 1px solid #ccc;
}
.error-modal {
  background-color: #1661ab2f;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}
.error-modal-body {
  position: absolute;
  top: 20%;
  width: 465px;
  height: 70%;
  border: 1px solid #1660ab;
  border-radius: 5px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.error-modal-body .error-error {
  margin-top: 30px !important;
  font-size: 13px;
  width: 306px;

  line-height: 1.38;
  flex: 5;
  height: 49px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  text-align: left;
}
.error-modal-body .error-close {
  width: auto;
  margin-top: 21px !important;
  height: 49px;
  padding-right: 18px;
  color: #fff;
}
.error-modal-body .error-message-btn {
  margin-top: 25px;
  height: 49px;
  flex: 0.8;
  font-size: 18px;
  color: #fff;
  padding-right: 18px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
@media screen and (max-width: 500px) {
  .error-modal-body {
    margin-top: 20%;
  }
  .close-btn {
    top: 24%;
    position: fixed;
    right: 40px;
  }
}
@media screen and (max-width: 800px) {
  .error-modal-body {
    margin-top: 10%;
    width: 80%;
    height: 60%;
  }
  .error-modal-body .error-img {
    left: 130px;
  }
}
</style>
